import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    GET_USER_NICKNAME: createAsyncActionConstants('GET_USER_NICKNAME'),
    SET_NICKNAME: 'SET_NICKNAME'
}